export default "__VITE_ASSET__Bk14FJ1I__"